module.exports = __webpack_public_path__ + "static/CircularStd-Bold-383b9b636e73394a14c9b4f0b9cd8e63.woff";